"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchableDropdown = function SearchableDropdown(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === undefined ? [] : _ref$options,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === undefined ? "Search..." : _ref$placeholder,
      onChange = _ref.onChange,
      lang = _ref.lang;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      searchQuery = _useState4[0],
      setSearchQuery = _useState4[1];

  var dropdownRef = (0, _react.useRef)(null);

  // Filter options based on search query
  var filteredOptions = options.filter(function (option) {
    var text = option.name ? option.name.toLowerCase() : option.toLowerCase();
    return text.includes(searchQuery.toLowerCase());
  }).sort(function (a, b) {
    var textA = a.name ? a.name.toLowerCase() : a.toLowerCase();
    var textB = b.name ? b.name.toLowerCase() : b.toLowerCase();

    // Prioritize matches that start with the searchQuery
    if (textA.startsWith(searchQuery.toLowerCase()) && !textB.startsWith(searchQuery.toLowerCase())) {
      return -1;
    }
    if (!textA.startsWith(searchQuery.toLowerCase()) && textB.startsWith(searchQuery.toLowerCase())) {
      return 1;
    }

    // Otherwise, sort alphabetically
    return textA.localeCompare(textB);
  });

  // Handle option selection
  var handleChange = function handleChange(option) {
    var selectedValue = option.name || option;
    if (!selectedValue) return; // Prevents navigation if the value is undefined

    setSearchQuery(selectedValue); // Update input field with selection
    setIsOpen(false);

    // Convert spaces to hyphens and navigate to the URL
    var formattedOption = selectedValue.toLowerCase().replace(/\s+/g, "-");

    // Use lang prop for navigation logic
    var url = lang === 'nl' ? "https://mijn.stad-gemeente.be/" + formattedOption : "https://ma.ville-commune.be/" + formattedOption;

    console.log("Navigating to:", url);
    window.location.href = url; // Navigate immediately on click
  };

  // Handle clicks outside the dropdown to close it
  (0, _react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      return document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return _react2.default.createElement(
    "div",
    { ref: dropdownRef, style: { position: "relative", width: "250px", margin: "10px auto" } },
    _react2.default.createElement("input", {
      type: "text",
      placeholder: placeholder,
      value: searchQuery,
      onChange: function onChange(e) {
        setSearchQuery(e.target.value);
        setIsOpen(true); // Open dropdown on typing
      },
      onClick: function onClick() {
        return setIsOpen(true);
      } // Open dropdown on focus
      , style: {
        width: "100%",
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        fontSize: "12px",
        outline: "none"
      }
    }),
    isOpen && _react2.default.createElement(
      "div",
      {
        style: {
          position: "absolute",
          width: "100%",
          top: "100%",
          left: "0",
          border: "1px solid #ccc",
          borderRadius: "5px",
          cursor: "pointer",
          zIndex: 10,
          background: "white",
          maxHeight: "150px",
          overflowY: "auto",
          padding: "5px",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)"
        }
      },
      filteredOptions.length > 0 ? filteredOptions.map(function (option, index) {
        return _react2.default.createElement(
          "div",
          {
            key: index,
            onClick: function onClick() {
              return handleChange(option);
            },
            style: {
              padding: "10px",
              fontSize: "12px",
              borderRadius: "5px",
              backgroundColor: "#fff",
              color: "#000",
              cursor: "pointer",
              transition: "background 0.2s"
            },
            onMouseEnter: function onMouseEnter(e) {
              return e.target.style.background = "#1794D2";
            },
            onMouseLeave: function onMouseLeave(e) {
              return e.target.style.background = "#fff";
            }
          },
          option.name || option
        );
      }) : _react2.default.createElement(
        "div",
        { style: { padding: "10px", fontSize: "12px", color: "#939598" } },
        "No options available"
      )
    )
  );
};

exports.default = SearchableDropdown;